import { LoadingCircleModule } from './../../../shared/component/common/loading-circle/loading-circle.module';
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ButtonModule } from "../../../shared/component/common/button/button.module";
import { LabelModule } from "../../../shared/component/common/label/label.module";
import { RadioModule } from "../../../shared/component/common/radio/radio.module";
import { RetryModule } from "../../../shared/component/common/retry/retry.module";
import { OverviewComponent } from "./overview.component";
import { HeaderV2Module } from "../../../shared/component/common/header-v2/header-v2.module";
import { CarontePixTokenService } from "../../../shared/service/caronte-pix/caronte-pix.service";
import { environment } from "src/environments/environment";

function initializeApp(service: CarontePixTokenService) {
  const setupAction$ = new Promise((resolve, reject) => {
    service.initializeSession().then(() => {
      service.addEntrypont(environment.carontePix.entryPoint)
        .subscribe({
          complete: () => {
            return resolve({});
          }, error: (ex) => console.log("endpoint error", ex)
        })
    })
      .catch(ex => {
        resolve({});
      })
  });
  return () => setupAction$;
}
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderV2Module,
    ButtonModule,
    LabelModule,
    RadioModule,
    RetryModule,
    LoadingCircleModule
  ],
  declarations: [OverviewComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [CarontePixTokenService],
      multi: true
    }
  ]
})
export class OverviewModule {}